import { RootState } from 'types';
import { initialState } from './placement-pay-package-status.redux';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state?.placementMarginPayPackageStatus || initialState;
export const selectPlacementMarginPayPackageStatusModalDetails = createSelector(
  [selectDomain],
  state => state?.payPackageStatusTransitionModalDetails,
);
export const selectPlacementMarginPayPackageStatusOptions = createSelector(
  [selectDomain],
  state => state?.payPackageStatusOptions,
);
export const selectPlacementMarginRecentStatusUpdatedScenarioId = createSelector(
  [selectDomain],
  state => state?.recentStatusUpdatedScenarioId,
);

export const selectPlacementMarginStatusUpdatedEmailModalOpen = createSelector(
  [selectDomain],
  state => state?.isEmailModalOpen,
);

export const selectPlacementMarginEmailRecipientsList = createSelector([selectDomain], state => state?.emailRecipients);
